import React from 'react';
import PropTypes from 'prop-types';
import differenceInDays from 'date-fns/difference_in_days';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import Price from 'Components/Utility/Price/Price';
import Tooltip from 'Components/Molecules/Tooltip';

import 'Components/Coupon/CouponSaving.scss';

const CouponSaving = ({
  hasExtraSaving,
  savingPrice,
  coupon,
  extraSavingPrice,
  isMonetary,
}) => {
  const daysLeft = differenceInDays(new Date(coupon.valid_until), new Date());

  if (isMonetary) return false;

  const component = className =>
    <div className={`coupon-saving ${className || ''}`}>
      <div className="coupon-applied-container">
        <span className="check-icon-container">
          <FontAwesomeIcon icon={faCheck} />
        </span>
        <span className="coupon-applied-text">
          <FormattedMessage id="couponsaving.couponapplied" defaultMessage="Coupon Applied" />
        </span>
      </div>
      <div className="saving-container">
        {hasExtraSaving ?
          <FormattedMessage id="couponsaving.extrasaving" defaultMessage="Extra Saving" />
          :
          <FormattedMessage id="couponsaving.saving" defaultMessage="Saving" />
        }
        <span className="saving-price">
          <Price
            price={hasExtraSaving ? extraSavingPrice : savingPrice}
          />
        </span>
      </div>
    </div>;

  return (
    <React.Fragment>
      <div className="d-none d-lg-block">
        <Tooltip
          ariaLabel="coupon applied, saving. Expand for more details"
          content={
            <div>
              {(daysLeft > 0 && daysLeft < 8) &&
                <FormattedMessage
                  id="couponsaving.messagone"
                  defaultMessage="Coupon {couponCode} expires in {daysLeft}."
                  values={{
                    couponCode: <b>{coupon.code}</b>,
                    daysLeft: <span>{daysLeft}<span>&nbsp;<FormattedMessage id="couponsaving.days" defaultMessage="days" /></span></span>,
                  }}
                />
              }
              {(!daysLeft || daysLeft > 7) &&
                <FormattedMessage
                  id="couponsaving.messagtwo"
                  defaultMessage="Coupon {couponCode}"
                  values={{
                    couponCode: <b>{coupon.code}</b>,
                  }}
                />
              }
              <br />
              <FormattedMessage
                id="couponsaving.messagetwo"
                defaultMessage="Price shown includes the coupon discount"
              />
            </div>
          }
        >
          {component()}
        </Tooltip>
      </div>
      {component('d-lg-none')}
    </React.Fragment>

  );
};

CouponSaving.propTypes = {
  hasExtraSaving: PropTypes.bool,
  savingPrice: PropTypes.shape({}).isRequired,
  coupon: PropTypes.shape({}),
  extraSavingPrice: PropTypes.shape({}),
  isMonetary: PropTypes.bool,
};

CouponSaving.defaultProps = {
  hasExtraSaving: false,
  coupon: {},
  extraSavingPrice: {},
  isMonetary: false,
};

export default CouponSaving;
